// extracted by mini-css-extract-plugin
export default {"delete-record-modal":"DeleteRecordModal_delete-record-modal__cVRu5","delete-record-actions":"DeleteRecordModal_delete-record-actions__S86AU"};